module.exports = __webpack_public_path__ + "img/57-image-2@2x.25e91b2d.png";